module.exports = __webpack_public_path__ + "img/iolite.efde6f47.png";